import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {setMessage} from './message';
import { resetSettings } from './setting';
import { persistor } from '../store';

import AuthService from '../services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));

export const register = createAsyncThunk(
  'auth/register',
  async ({username, email, password}, thunkAPI) => {
    try {
      const response = await AuthService.register(username, email, password);
      thunkAPI.dispatch(setMessage(response.data.message));
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const login = createAsyncThunk(
  'auth/login',
  async ({email, password}, thunkAPI) => {
    try {
      const data = await AuthService.login(email, password);
      return {user: data};
    } catch (error) {
        console.error('Login Error:', error);

        const parseErrorMessage = (err) => {
            if (err.response && err.response.data) {
                return err.response.data.detail || err.response.data.message || 'An error occurred during login.';
            }
            return err.message || err.toString();
        };

        const message = parseErrorMessage(error);
        thunkAPI.dispatch(setMessage(message));

        return thunkAPI.rejectWithValue(message);
    }
  },
);

export const logoutAndReset = () => async (dispatch) => {
  try {
   
    await persistor.flush();
   
    dispatch(resetSettings());
     dispatch(resetAuthData());

    await AuthService.logout();
  } catch (error) {
    // even if backend logout fails, local logout must succeed
    console.error('Logout error:', error);
  }
};


const initialState = user
  ? {error: null, isLoggedIn: true, user}
  : {error: null, isLoggedIn: false, user: null};

const authSlice = createSlice({
  name: 'auth',
  initialState,
   reducers: {
      //resetAuthData: () => initialState,
       resetAuthData: (state) => {
      state.isLoggedIn = false; // This will clear the list
      state.user = null;
    },
    },
  extraReducers: builder => {
    builder
      .addCase(register.fulfilled, (state, action) => {
        state.isLoggedIn = false;
      })
      .addCase(register.rejected, (state, action) => {
        state.isLoggedIn = false;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        state.user = action.payload.user.data.userData;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoggedIn = false;
        state.user = null;
        state.error = action.payload;
      });
  },
});

export const { resetAuthData } = authSlice.actions;
export default authSlice.reducer;

